/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Pink_Leopard_FadeInputs */

const fr_extra_pink_leopard_fade = /** @type {(inputs: Extra_Pink_Leopard_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton 1RM théorique est `)
};

/**

* @param {Extra_Pink_Leopard_FadeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_pink_leopard_fade = /** @type {((inputs?: Extra_Pink_Leopard_FadeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Pink_Leopard_FadeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_pink_leopard_fade(inputs)
});